import React from "react";

interface Props {
	loadMore: () => void;
}

const TrainingContentSeeMore: React.FC<Props> = ({loadMore}) => {
	return (
		<button className="cih-btn-load-more" onClick={loadMore}>
			<div className="cih-ico-circle">
				<div className="cih-ico-txt">+</div>
			</div>
			<span>See more</span>
		</button>
	);
};

export default TrainingContentSeeMore;
